export class UserAverageSessions {
  constructor(userAverageSessions) {
    this.id = userAverageSessions.userId;
    this.sessions = userAverageSessions.sessions;
  }
}
